import { combineReducers } from 'redux';

import UserReducer from './user/UserReducer';
import ObservationReducer from './observation/ObservationReducer';
import SettingReducer from './setting/SettingReducer';

const RootReducer = combineReducers({
    User: UserReducer,
    Observation: ObservationReducer,
    Setting: SettingReducer
});

export type ReduxStore = ReturnType<typeof RootReducer>
export default RootReducer;